/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Stat type for the given Asset.
 *
 */
export var StatType;
(function (StatType) {
    StatType["ENERGY"] = "energy";
    StatType["FEEDSTOCK"] = "feedstock";
    StatType["RUNNING_HOURS"] = "runningHours";
    StatType["PRODUCTIVITY"] = "productivity";
})(StatType || (StatType = {}));
